import Image from 'next/image';
import { useRef } from 'react';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

interface IProps {
    id: string;
    title: string;
    label: string;
    documentName: string;
    uploadStatus: string;
    isMandatory: boolean;
    disabled?: boolean;
    onSelect: any;
    onDelete: any;
}

function DocumentUpload({
    id,
    title,
    label,
    documentName,
    uploadStatus,
    isMandatory,
    disabled = false,
    onSelect,
    onDelete,
}: IProps) {
    const hiddenFileInput: any = useRef(null);

    const handleClick = () => {
        if (disabled) return;
        hiddenFileInput?.current?.click();
    };

    const handleChange = (event) => {
        if (disabled) return;
        onSelect?.(id, event.target.files[0]);
    };

    const getUploadStatusIcon = () => {
        if (uploadStatus === '') {
            return '/icons/greenPlus.svg';
        }
        if (uploadStatus === 'uploading') {
            return '/gif/greenCircleLoader.gif';
        }
        if (uploadStatus === 'uploaded') {
            return '/icons/greenTickFill.svg';
        }
        if (uploadStatus === 'failed') {
            return '/icons/failed.svg';
        }
        return '/icons/trash.svg';
    };

    return (
        <Styles.Wrapper>
            <Styles.TitleFlex>
                <Styles.Title>{title}</Styles.Title>
                {isMandatory && <Styles.MandatorySign>*</Styles.MandatorySign>}
            </Styles.TitleFlex>
            <Styles.FileUploadInput>
                <Styles.FileUploadWrapper
                    isUploaded={uploadStatus === 'uploaded'}
                    onClick={handleClick}
                >
                    <Styles.PlusIconFlex>
                        <Image
                            width={'24px'}
                            height={'24px'}
                            alt={''}
                            src={getImageBasePath(getUploadStatusIcon())}
                        />
                    </Styles.PlusIconFlex>
                    <Styles.UploadLabel>
                        {uploadStatus
                            ? `${documentName.substring(0, 20)}...`
                            : label}
                    </Styles.UploadLabel>
                    {uploadStatus === 'uploaded' && !disabled && (
                        <Styles.DeleteIconFlex onClick={(e) => onDelete(e, id)}>
                            <Image
                                width={'20px'}
                                height={'20px'}
                                alt={''}
                                src={getImageBasePath('/icons/trash.svg')}
                            />
                        </Styles.DeleteIconFlex>
                    )}
                </Styles.FileUploadWrapper>
                {!disabled &&
                    (uploadStatus === '' || uploadStatus === 'failed') && (
                        <input
                            type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange}
                            style={{ display: 'none' }}
                        />
                    )}
            </Styles.FileUploadInput>
        </Styles.Wrapper>
    );
}

export default DocumentUpload;
